const getBrands = ({ brandState }) => brandState.brands;

export { getBrands };
